import type { CSSObject } from "styled-components";
import { black } from "./colors";

/** Shared between plain anchors and router `Link`s, hence a bare style object. */
export const actionButtonStyles: CSSObject = {
  padding: "12px 20px",
  border: `1px solid ${black}`,
  borderRadius: 8,
  fontWeight: 600,
};
